export const importersEn = {
  "importers.readiness.count.pos_stock_operations": "Stock corrections and transfers",
  "importers.readiness.count.pos_stock_operation_entries": "Correction movement entries",

  "importers.readiness.count.pos_jonas_records": "Source catalogue rows",
  "importers.readiness.count.pos_jonas_drafts": "Item source links",
  "importers.readiness.count.pos_jonas_reviews": "Imported item reviews",
  "importers.readiness.count.pos_prices": "Native outlet prices",
  "importers.readiness.count.pos_stock_locations": "Stock locations",
  "importers.readiness.count.pos_stock_receipts": "Receiving records",
  "importers.readiness.count.pos_stock_movements": "Receipt stock movements",
  "importers.readiness.count.gl_jonas_records": "Staged GL records",
  "importers.readiness.count.gl_accounts": "Native accounts",
  "importers.readiness.count.gl_lines": "Native journal lines",
  "importers.readiness.count.lodging_jonas_records": "Staged lodging records",
  "importers.readiness.count.lodging_units": "Rooms and cottages",
  "importers.readiness.count.lodging_stays": "Native stays",
  "importers.readiness.count.lodging_history_charges": "Historical charges",
  "importers.readiness.count.document_index_entries": "Source index entries",
  "importers.readiness.count.document_import_files": "Imported source files",
  "importers.readiness.count.documents": "Linked documents",
  "importers.readiness.count.document_blobs": "Stored document files",

  "importers.readiness.title": "Migration readiness",
  "importers.readiness.help": "Counts show staged data, not complete migration. Source reconciliation and approved financial and stock openings are still required.",
  "importers.readiness.generated": "Checked",
  "importers.readiness.reconcile": "Data present — reconcile against source",
  "importers.readiness.partial": "Missing or partial",
  "importers.readiness.unavailable": "Not installed",
  "importers.readiness.review": "Open review",
  "importers.readiness.printing": "Live printing interlocks",
  "importers.readiness.printCounts": "{agents} agents · {server} server enabled · {local} local enabled · {unknown} local status unknown",
  "importers.readiness.disabled": "Server and reported local printing are disabled.",
  "importers.readiness.unconfirmed": "Do not print: at least one printing status is enabled, unknown, or no agent has reported.",

  "importers.runs.title": "Import history",
  "importers.runs.subtitle": "Every run of an importer, newest first, including trial runs that kept nothing.",
  "importers.runs.show": "Show",
  "importers.runs.realOnly": "Real runs",
  "importers.runs.dryOnly": "Trial runs",
  "importers.runs.empty": "No imports yet",
  "importers.runs.emptyBody": "Runs appear here once an importer has been run for this club.",

  "importers.run.dryRun": "Trial run",
  "importers.status.running": "Running",
  "importers.status.completed": "Completed",
  "importers.status.failed": "Failed",
  "importers.run.file": "File",
  "importers.run.runBy": "Run by",
  "importers.run.started": "Started",
  "importers.run.finished": "Finished",
  "importers.run.duration": "Duration",
  "importers.run.created": "Created",
  "importers.run.updated": "Updated",
  "importers.run.unchanged": "Unchanged",
  "importers.run.skipped": "Skipped",
  "importers.run.warnings": "Warnings",
  "importers.run.errors": "Errors",
  "importers.run.about": "This run",
  "importers.run.status": "Status",
  "importers.run.importer": "Importer",
  "importers.run.fileSize": "File size",
  "importers.run.bytes": "{size} bytes",
  "importers.run.sha": "File fingerprint (SHA-256)",
  "importers.run.failed": "The run failed: {message}",
  "importers.run.counts": "Counts",
  "importers.run.rowsRead": "Rows read",
  "importers.run.absent": "Members absent from the file",
  "importers.run.householdsCreated": "Households created",
  "importers.run.householdsUpdated": "Households updated",
  "importers.run.householdsUnchanged": "Households unchanged",
  "importers.run.license": "License member count",
  "importers.run.licenseUnknown": "This run did not record a license count.",
  "importers.run.licenseNoLimit": "{count} members count against the license. The license sets no limit.",
  "importers.run.licenseCount": "{count} of {limit} members counted against the license",
  "importers.run.overLimit": "Over the limit",
  "importers.run.overLimitBody": "The club cannot add or reactivate members until it is back under the limit. Existing members are untouched.",
  "importers.run.options": "Options used",
  "importers.run.defaultOptions": "The defaults were used.",
  "importers.run.summary": "Other things this run created",

  "importers.issues.title": "Issues",
  "importers.issues.privacy": "Issues name a member number and a column, never a value from the file. Open the member to see the value.",
  "importers.issues.severity": "Severity",
  "importers.issues.code": "Code",
  "importers.issues.memberNumber": "Member number",
  "importers.issues.column": "Column",
  "importers.issues.row": "Row",
  "importers.issues.message": "What happened",
  "importers.issues.count_one": "{count} issue shown",
  "importers.issues.count_other": "{count} issues shown",
  "importers.issues.none": "No issues",
  "importers.issues.noneBody": "This run found nothing to report.",
  "importers.issues.noMatch": "No matching issues",
  "importers.issues.noMatchBody": "Clear a filter to see more.",
  "importers.issues.occurrences": "(×{count} rows)",
  "importers.severity.error": "Error",
  "importers.severity.warning": "Warning",
  "importers.severity.info": "Note",

  "importers.history.title": "History from Jonas",
  "importers.history.none": "No history from Jonas has been imported yet. Reports cover activity in ClubCore only.",
  "importers.history.noneSince": "No history from Jonas has been imported yet. Reports cover activity in ClubCore since {date}.",
  "importers.history.memberLoaded": "Member spending history loaded",
  "importers.history.memberMissing": "Member spending history not imported",
  "importers.history.memberRange": "{count} transactions, {from} to {to}.",
  "importers.history.payablesLoaded": "Payables history loaded",
  "importers.history.payablesStaged": "Payables received, expenses not built yet",
  "importers.history.payablesMissing": "Payables history not imported",
  "importers.history.payablesRange": "{count} expenses, {from} to {to}.",
  "importers.history.lastLoaded": "Last batch loaded {when}.",
  "importers.history.apply.queued": "Build step waiting to start",
  "importers.history.apply.running": "Build step running",
  "importers.history.apply.done": "Build step finished",
  "importers.history.apply.failed": "Build step failed",
  "importers.history.applyWhen": "Former members, links, vendors and expenses; {when}.",
  "importers.history.applyError": "The last attempt stopped with: {error}",
  "importers.history.cutOver": "Reports take spending from the history through {date} and from ClubCore after it.",
  "importers.history.sources": "Sources loaded",
  "importers.history.completenessBoundary": "Received batches are evidence of an import, not proof that all Jonas data was supplied or accepted.",
  "importers.history.unlinkedHouseholds": "Member transactions without a household: {count}",
  "importers.history.unlinkedSuppliers": "Imported expenses without a supplier: {count}",
  "importers.history.receivedRows": "Received rows",
  "importers.history.skippedRows": "Skipped rows",
  "importers.history.notReceived": "No batch received",
  "importers.history.source.former_members": "Former members",
  "importers.history.source.pos_items": "POS history lines",
  "importers.history.source": "Source",
  "importers.history.batches": "Batches",
  "importers.history.rows": "Rows",
  "importers.history.covers": "Dates",
  "importers.history.loadedAt": "Last loaded",
  "importers.history.source.member_tx": "Member transactions",
  "importers.history.source.vendors": "Vendors",
  "importers.history.source.ap_invoices": "Payables invoices",
  "importers.history.source.gl_ap_lines": "Payables ledger lines",
  "importers.history.source.gl_monthly": "General ledger by month",
  "importers.history.source.cheques": "Cheques",
  "importers.history.source.cheque_invoices": "Cheque invoices",
  "importers.history.source.codes": "Code tables",
  "importers.history.source.gl_accounts": "Chart of accounts",
  "importers.history.source.gl_divisions": "Ledger divisions",
  "importers.recon.title": "Jonas balance reconciliation",
  "importers.recon.subtitle": "Each account's Jonas history, recorded before the opening-balance day, against its Jonas balance brought forward. Jonas's balance is kept; nothing here posts.",
  "importers.recon.download": "Download CSV",
  "importers.recon.show": "Show",
  "importers.recon.differsOnly": "Accounts that differ",
  "importers.recon.all": "Every account",
  "importers.recon.counts": "{households} accounts: {matches} match, {differs} differ.",
  "importers.recon.emptyTitle": "Nothing differs",
  "importers.recon.emptyBody": "Every account's history adds up to its Jonas balance.",
  "importers.recon.account": "Account",
  "importers.recon.member": "Member",
  "importers.recon.history": "History total",
  "importers.recon.jonas": "Jonas balance",
  "importers.recon.difference": "Difference",
  "importers.recon.state": "Result",
  "importers.recon.state.matches": "Matches",
  "importers.recon.state.differs": "Differs",
  "importers.recon.state.no_history": "No history",
  "importers.recon.state.nothing": "No history, no balance",
} as const satisfies Record<string, string>;

export type ImportersMessages = typeof importersEn;
